import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  orderListParams,
  orderListQueryOptions,
  orderListSearchSchema,
  OrdersPage,
} from '@/features/orders';

export const Route = createFileRoute('/_authed/_active/s/$storeId/orders/')({
  staticData: { tours: ['orders.list'] },
  validateSearch: orderListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...orderListQueryOptions(params.storeId, orderListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second click in the picker would build on the stale filters. The
    // page's own query shows the previous rows meanwhile.
    if (cause !== 'stay') await prefetch;
  },
  component: OrdersPage,
});
